import React, { Component } from "react";
import "./ColorPaletteItem.css";
import { linkOrButtonOptions } from "../../data/linkOrButtonOptions";
import { buttonStyles } from "../../data/buttonStyles";
import SpinnerBox from "./SpinnerBox";
import { api } from "../../data/urls";
import axios from "axios";
import returnAuthHeaderForAJAX from "../../helpers/auth/returnAuthHeaderForAJAX";
import { openNotification } from "../../helpers/openNotification";
import AbstractIcon from "../../pageComponents/component_molecules/AbstractIcon";
import WebsiteButton from "../../pageComponents/component_molecules/WebsiteButton";
import _ from "lodash";
import { connect } from "react-redux";
import { getCurrentStoreData } from "../../store/websites/thunks";
import { GetCurrentStoreData } from "../../store/websites/types";
import { toggleWaitingForResponseOnColorPaletteChange } from "../../store/websites/actions";
import classNames from "classnames";
import "./NavSidebar/NavSidebar.scss";
import LoaderAnimated from "./LoaderAnimated";

interface Props {
  styleClassname: string;
  styleTitle: string;
  auth: any;
  saveWebsiteDataInStore: any;
  websites: any;
  toggleWaitingForResponseOnColorPaletteChange: any;
  getCurrentStoreData: GetCurrentStoreData;
  colorItem: any;
}

class ColorPaletteItem extends Component<Props> {
  state = {
    beingActivated: false,
    isLoading: false,
  };

  setIsLoading = (isLoading: boolean) => {
    this.setState({ isLoading });
  };

  applyNewStyle = (styleClassname: string) => {
    const { currentWebsite } = this.props.getCurrentStoreData();
    this.props.toggleWaitingForResponseOnColorPaletteChange(true);
    this.setState({ beingActivated: true });
    this.setIsLoading(true);
    let accessToken = this.props.auth.accessToken;
    let apiUrl =
      api.websites.updateWebsite.prefix +
      currentWebsite.subdomain +
      api.websites.updateWebsite.postfix;
    const customPalette = _.get(currentWebsite, "custom_color_palette", {});
    const updatedCustomPalette = {
      ...customPalette,
      isCustomPaletteActivated: false,
    };
    axios
      .patch(
        apiUrl,
        {
          color_classname: styleClassname,
          custom_color_palette: updatedCustomPalette,
        },
        { ...returnAuthHeaderForAJAX(accessToken) }
      )
      .then(() => {
        const dataToStore = {
          data: {
            ...currentWebsite,
            color_classname: styleClassname,
            custom_color_palette: updatedCustomPalette,
          },
        };
        this.props.saveWebsiteDataInStore(
          dataToStore,
          currentWebsite.subdomain
        );
      })
      .catch((error) => {
        if (error.response) {
          let errorData = error.response.data;
          if (errorData.detail !== undefined) {
            let message = errorData.detail;
            openNotification(
              "Server error",
              'Error message: "' +
                message +
                '". This should not have happened. Please contact us.',
              "OK",
              "error"
            );
          }

          if (errorData.locked !== undefined) {
            let message = errorData.locked;
            openNotification("Denied", message, "OK", "warn");
          }

          if (errorData.color_classname !== undefined) {
            let message = errorData.subdomain.join(" ");
            openNotification("Denied", message, "OK", "warn");
          }
        }
      })
      .then((response) => {
        // always executed
        this.props.toggleWaitingForResponseOnColorPaletteChange(false);
        this.setState({ beingActivated: false });
        this.setIsLoading(false);
      });
  };

  render() {
    const { currentWebsite } = this.props.getCurrentStoreData();
    if (!currentWebsite) return null;
    const isCustomPaletteActive = _.get(
      currentWebsite,
      "custom_color_palette.isCustomPaletteActivated",
      false
    );
    let isActive =
      currentWebsite.color_classname === this.props.styleClassname &&
      !isCustomPaletteActive;
    let isDisabled =
      this.props.websites.isWaitingForChangeColorPaletteServerResponse;

    return (
      <button
        onClick={() => {
          this.applyNewStyle(this.props.styleClassname);
        }}
        className={classNames(
          `nav-sidebar__theme-item ${this.props.styleClassname}`,
          {
            "is-active": isActive,
            "is-disabled": isDisabled,
            "is-loading": this.state.isLoading,
          }
        )}
        disabled={isDisabled}
      >
        {this.state.isLoading && <LoaderAnimated />}
        {!this.state.isLoading && (
          <>
            <span
              style={{
                background: "var(--light)",
              }}
              className="nav-sidebar__theme-item__color-box"
            />
            <span
              style={{
                background: "var(--primary)",
              }}
              className="nav-sidebar__theme-item__color-box"
            />
            <span
              style={{
                background: "var(--dark)",
              }}
              className="nav-sidebar__theme-item__color-box"
            />
          </>
        )}
      </button>
    );
  }
}

const mapStateToProps = (state: any) => ({
  websites: state.websites,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getCurrentStoreData,
  toggleWaitingForResponseOnColorPaletteChange,
})(ColorPaletteItem);
